import { Box, Heading, HStack, VStack, Flex } from '@chakra-ui/react'
import { useState } from 'react'
import UserMenu from '../../../../app/components/UserMenu'
import { useUser } from '../../../../context/UserContext'
import { useGetDevicesByEmailQuery, useGetDevicesLiteQuery } from '../../api/api'
import DeviceList from './DeviceList'
import RegisterDeviceCard from './RegisterDeviceCard'

export default function DeviceConfigurationSettings() {
  const { user } = useUser()
  const [search, setSearch] = useState('')

  const { data } = useGetDevicesByEmailQuery({ email: user?.username })

  const {
    data: liteDevices,
    isFetching,
    isLoading,
  } = useGetDevicesLiteQuery({
    tenantId: user.tenant?.id,
  })

  const devicesCount = liteDevices?.length || 0

  return (
    <Flex direction="column" gap={8}>
      <HStack w="100%" justify="space-between" align="center">
        <Heading size="md">Device configuration</Heading>
        <UserMenu />
      </HStack>

      <Flex direction="column">
        <Heading fontSize="17px" mb={4} fontWeight="light" color="gray.600">
          Register new device/s
        </Heading>
        <VStack
          spacing={0}
          divider={<Box h="1px" bg="gray.200" w="full" />}
          border="1px solid"
          borderColor="gray.200"
          borderRadius="xl"
          overflow="hidden"
        >
          <RegisterDeviceCard
            type="physical"
            title="Register physical devices"
            data={data}
            subtitle={
              data?.count > 0
                ? `You have ${data?.count} ${
                    data?.count === 1 ? 'device' : 'devices'
                  } awaiting`
                : undefined
            }
          />
        </VStack>
      </Flex>

      <Flex direction="column">
        <Box position="relative" maxWidth="fit-content">
          <Heading fontSize="17px" mb={4} fontWeight="light" color="gray.600">
            Manage your device/s
          </Heading>
          {devicesCount !== undefined && devicesCount > 0 && (
            <Box
              position="absolute"
              top="-5px"
              right="-35px"
              bg="blue.500"
              color="white"
              borderRadius="full"
              fontSize="sm"
              fontWeight="bold"
              width="30px"
              height="30px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              border="2px solid white"
              lineHeight="1"
              textAlign="center"
              paddingRight="0.4"
            >
              {devicesCount}
            </Box>
          )}
        </Box>
        <DeviceList
          devices={liteDevices || []}
          search={search}
          setSearch={setSearch}
          isFetching={isFetching || isLoading}
        />
      </Flex>
    </Flex>
  )
}
